/**
 * Media queries for pointer and hover detect the primary input type,
 * queries for any-pointer and any-hover detect if any input mechanism matches.
 * TODO: implment any-queries when specification has been refined. See test results @ https://patrickhlauke.github.io/touch/pointer-hover-any-pointer-any-hover/results/
 *
 * More on Media Queries here https://www.smashingmagazine.com/2022/03/guide-hover-pointer-media-queries/
 */

type pointerType =
    | 'none' // no pointer, eg. phones
    | 'coarse' // limited accuracy, eg. smart tv remote or console controller
    | 'fine'; // high accuracy, eg. mouse, touchpad or stylus

type hoverType =
    | 'none' // no hover
    | 'hover'; // all the hover

function pointer(type: pointerType) {
    return `@media (pointer: ${type})`;
}

function hover(type: hoverType) {
    return `@media (hover: ${type})`;
}

export { pointer, hover };
